import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GalavailRestService } from 'clientwsGalavail';
import { Observable } from 'rxjs';
import { HttpClientGenericService } from 'src/app/services/http-client-generic.service';

@Injectable({
  providedIn: 'root'
})
export class OnholdService {

  // URL del servicio onHoldMultiple (multi-salida). La base depende del ambiente
  // (develop: https://develop.api.galavail.com/webservice/); para producción ajustar
  // conforme a la configuración de la librería del entorno correspondiente.
  private readonly onHoldMultipleUrl =
    'https://develop.api.galavail.com/webservice/royalWSAPI/onHoldMultiple/';
    //'https://develop.api.galavail.com/webservice/royalWSAPI/onHold/';

  constructor(
    private galavailRestService: GalavailRestService,
    private httpClientGenericService: HttpClientGenericService
  ) { }

  public onHold(requestOnhold: any): Observable<any> {
    const httpHeaders: HttpHeaders = new HttpHeaders({});
    const restServiceItemName = 'requestG_blockCabin';
    return this.galavailRestService.request<any>(null,
      restServiceItemName, { headers: httpHeaders }, requestOnhold,requestOnhold.email);
  }

  // Flujo múltiple (multi-onhold): publica el body multi-salida en el endpoint
  // dedicado onHoldMultiple (sin el header Basic; requerimiento del backend).
  public onHoldMultiple(requestOnhold: any): Observable<any> {
    return this.httpClientGenericService.requestPost(
      this.onHoldMultipleUrl,
      requestOnhold
    );
  }
}
